import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { RepUserFilters } from './RepUserSearchForm';
import { UserListResponseUsersItem } from '@platform/client/schemas';
import { useContext } from 'react';
import { AdminTable, AdminTableContext } from '../../../AdminTable';
import { ModalCallToAction } from '@platform/components';
import { keepPreviousData } from '@tanstack/react-query';
import { AdminSearch } from '@platform/client';
import { repFiltersToQueryParams } from '../utils';
import { useMemo } from 'react';

const repUserColumnHelper = createColumnHelper<UserListResponseUsersItem>();

export const RepUserResultsTable = (props: {
  filters: RepUserFilters;
  setFilters: React.Dispatch<React.SetStateAction<RepUserFilters | undefined>>;
  setDownloadModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { filters, setFilters, setDownloadModalOpen } = props;
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const { data, isSuccess, isLoading, isError } = AdminSearch.useGetRepUsers(
    {
      ...repFiltersToQueryParams(filters),
      page: adminQueryOptionsV2.page,
      limit: adminQueryOptionsV2.limit,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
  const { users = [], filteredCount = 0 } = data || {};
  const columns = useMemo(() => {
    return [
      repUserColumnHelper.accessor('id', {
        header: 'ID',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('firstName', {
        header: 'First name',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('lastName', {
        header: 'Last name',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('email', {
        header: 'Email',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('organizationId', {
        header: 'Organization ID',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('organizationName', {
        header: 'Organization name',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('organizationApplicationStatus', {
        header: 'Application status',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('timezone', {
        header: 'Timezone',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('corporateClient', {
        header: 'Corporate client',
        cell: (info) => info.getValue(),
      }),
      repUserColumnHelper.accessor('impactPartners', {
        header: 'Impact partners',
        cell: (info) => {
          return info.getValue();
        },
      }),
    ] as ColumnDef<UserListResponseUsersItem>[];
  }, []);

  const tableActions: ModalCallToAction[] = [
    {
      text: 'Modify filters',
      callback: () => {
        setFilters(undefined);
      },
    },
  ];
  if (isSuccess && users.length > 0) {
    tableActions.push({
      text: 'Export results',
      callback: () => {
        setDownloadModalOpen(true);
      },
    });
  }

  return (
    <AdminTable
      data={users}
      filteredCount={filteredCount}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      enableSorting={false}
      tableActions={tableActions}
    />
  );
};
